var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.42 31.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#8d1f33;}.cls-3{fill:#fafafa;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.71,
    cy: 15.71,
    r: 15.71
  }), /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.71,2.16h0A13.55,13.55,0,0,1,29.26,15.71h0A13.55,13.55,0,0,1,15.71,29.26h0A13.55,13.55,0,0,1,2.16,15.71h0A13.55,13.55,0,0,1,15.71,2.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "15.4 21.77 16.01 21.77 16.01 16.01 21.77 16.01 21.77 15.4 15.71 15.4 15.4 15.71 15.4 21.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16.01 9.65 15.4 9.65 15.4 15.4 9.65 15.4 9.65 16.01 15.71 16.01 16.01 15.71 16.01 9.65"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMas);
export default __webpack_public_path__ + "static/media/mas.59532849164c3dfae73970a5d0a28f23.svg";
export { ForwardRef as ReactComponent };